import * as types from './mutation-types'

export const fetchFinancesForms = ({ commit, dispatch, state }, params) => {
  return new Promise((resolve, reject) => {
    window.axios.get(`/api/super/admin/finances-forms`, { params }).then((response) => {
      if (response.data.success === true) {
        commit(types.BOOTSTRAP_FINANCES_FORMS, response.data.financesForms)
        commit(types.SET_TOTAL_FINANCES_FORMS, response.data.financesForms.total)
      }
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}
export const createFinancesForm = ({ commit, dispatch, state }, params) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`/api/super/admin/finances-forms/create`, { params }).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const addFinancesForm = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
      window.axios.post('/api/super/admin/finances-forms', data).then((response) => {
          resolve(response)
      }).catch((err) => {
          reject(err)
      })
  })
}

export const viewFinancesForm = ({ commit, dispatch }, id) => {
  return new Promise((resolve, reject) => {
      window.axios.get(`/api/super/admin/finances-forms/${id}/view`).then((response) => {
          resolve(response)
      }).catch((err) => {
          reject(err)
      })
  })
}

export const editFinancesForm = ({ commit, dispatch }, id) => {
  return new Promise((resolve, reject) => {
      window.axios.get(`/api/super/admin/finances-forms/${id}/edit`).then((response) => {
          resolve(response)
      }).catch((err) => {
          reject(err)
      })
  })
}

export const updateFinancesForm = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
      window.axios.put(`/api/super/admin/finances-forms/${data.id}`, data).then((response) => {
          resolve(response)
      }).catch((err) => {
          reject(err)
      })
  })
}

export const deleteFinancesForm = ({ commit, dispatch, state }, id) => {
  return new Promise((resolve, reject) => {
    window.axios.delete(`/api/super/admin/finances-forms/${id}`).then((response) => {
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}
